import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { MICROSERVICES } from '@shared/constants/microservices';
import { Observable } from 'rxjs/internal/Observable';
import { CreateVehicleResponse, GetVehicleResponse, UpdateVehicleResponse, UserVehiclesResponse } from '../domain/vehicle.model';
import { CreateVehicleDto, UpdateVehicleDto } from './dto/vehicle.dto';
import { VehiclesRepository } from './vehicles.repository';

@Injectable()
export class VehiclesApiService implements VehiclesRepository {
    private _http = inject(HttpClient);

    createVehicle(createVehicleDto: CreateVehicleDto): Observable<CreateVehicleResponse> {
        return this._http.post<CreateVehicleResponse>(`${environment.url}/${MICROSERVICES.ruc_vehicles}/vehicles`, createVehicleDto);
    }
    listUserVehicles(page = 1, pageSize = 30, includeDraft = false): Observable<UserVehiclesResponse> {
        let params = new HttpParams().set('page', page).set('size', pageSize);
        if (includeDraft) {
            params = Object.assign(params, { includeDraft });
        }
        const options = {
            params,
        };
        return this._http.get<UserVehiclesResponse>(`${environment.url}/${MICROSERVICES.ruc_vehicles}/vehicles`, options);
    }
    updateVehicle(id: string, updateVehicleDto: UpdateVehicleDto): Observable<UpdateVehicleResponse> {
        return this._http.patch<UpdateVehicleResponse>(`${environment.url}/${MICROSERVICES.ruc_vehicles}/vehicles/${id}`, updateVehicleDto);
    }

    getVehicle(id: string): Observable<GetVehicleResponse> {
        return this._http.get<GetVehicleResponse>(`${environment.url}/${MICROSERVICES.ruc_vehicles}/vehicles/${id}`);
    }
}
